
import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from 'src/composables/auth';


function passRouteToProps(route) {
	return {
		queryParams: route.query,
		fieldName: route.params.fieldName,
		fieldValue: route.params.fieldValue
	}
}


let routes = [
	//matriculation oath
	{
		path: '/home/matriculationoath',
		name: 'matriculationoath',
		component: () => import('./pages/home/matriculationoath.vue'),
		props: route => passRouteToProps(route)
	},
  
  //courses routes
	{
		path: '/courses/:fieldName?/:fieldValue?',
		name: 'courseslist',
		component: () => import('./pages/courses/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/courses/results',
		name: 'coursesresults',
		component: () => import('./pages/courses/results.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/courses/evaluation',
		name: 'coursesevaluation',
		component: () => import('./pages/courses/evaluation.vue'),
		props: route => passRouteToProps(route)
	},
  {
		path: '/courses/evaluation/add/:id',
		name: 'coursesevaluationadd',
		component: () => import('./pages/courses/evaluationadd.vue'),
		props: true
	},
	{
		path: '/courses/view',
		name: 'coursesview',
		component: () => import('./pages/courses/view.vue'),
		props: true
	},

	{
		path: '/courses/specialresit',
		name: 'coursesspecialresit',
		component: () => import('./pages/courses/specialresit.vue'),
		props: true
	},


	//coursesenrolment routes
	{
		path: '/coursesenrolment/:fieldName?/:fieldValue?',
		name: 'coursesenrolmentlist',
		component: () => import('./pages/coursesenrolment/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/coursesenrolment/view/:id',
		name: 'coursesenrolmentview',
		component: () => import('./pages/coursesenrolment/view.vue'),
		props: true
	},
	{
		path: '/coursesenrolment/add',
		name: 'coursesenrolmentadd',
		component: () => import('./pages/coursesenrolment/add.vue'),
		props: true
	},
	{
		path: '/coursesenrolment/edit/:id',
		name: 'coursesenrolmentedit',
		component: () => import('./pages/coursesenrolment/edit.vue'),
		props: true
	},


	//studentclearance routes
	{
		path: '/studentclearance/:fieldName?/:fieldValue?',
		name: 'studentclearancelist',
		component: () => import('./pages/studentclearance/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/studentclearance/add',
		name: 'studentclearanceadd',
		component: () => import('./pages/studentclearance/add.vue'),
		props: true
	},


	//students routes
	{
		path: '/account/edit',
		name: 'studentsaccountedit',
		component: () => import('./pages/account/accountedit.vue'),
		props: true
	},
	{
		path: '/account',
		name: 'studentsaccountview',
		component: () => import('./pages/account/accountview.vue'),
		props: true
	},

	//studentalerts routes
	{
		path: '/notifications/:fieldName?/:fieldValue?',
		name: 'studentalertslist',
		component: () => import('./pages/studentalerts/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/notifications/view/:id',
		name: 'studentalertsview',
		component: () => import('./pages/studentalerts/view.vue'),
		props: true
	},
	{
		path: '/studentalerts/:fieldName?/:fieldValue?',
		name: 'studentalertstodayalert',
		component: () => import('./pages/studentalerts/todayalert.vue'),
		props: route => passRouteToProps(route)
	},

	//documentrequests routes
	{
		path: '/documentrequests/:fieldName?/:fieldValue?',
		name: 'documentrequestslist',
		component: () => import('./pages/documentrequests/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/documentrequests/view/:id',
		name: 'documentrequestsview',
		component: () => import('./pages/documentrequests/view.vue'),
		props: true
	},
	{
		path: '/documentrequests/add',
		name: 'documentrequestsadd',
		component: () => import('./pages/documentrequests/add.vue'),
		props: true
	},
	{
		path: '/documentrequests/edit/:id',
		name: 'documentrequestsedit',
		component: () => import('./pages/documentrequests/edit.vue'),
		props: true
	},
	{
		path: '/documentrequests/cancel/:id',
		name: 'documentrequestscancel',
		component: () => import('./pages/documentrequests/cancel.vue'),
		props: true
	},

	//timetables routes
	{
		path: "/timetables/examstimetable/:fieldName?/:fieldValue?",
		name: "studenttimetablelist",
		component: () => import("./pages/timetables/examstimetable.vue"),
		props: (route) => passRouteToProps(route),
	},
	{
		path: "/timetables/lecturetimetable/:fieldName?/:fieldValue?",
		name: "lecturetimetablelist",
		component: () => import("./pages/timetables/lecturetimetable.vue"),
		props: (route) => passRouteToProps(route),
	},
	
	//payments routes
	{
		path: '/payments/:fieldName?/:fieldValue?',
		name: 'paymentslist',
		component: () => import('./pages/payments/list.vue'),
		props: route => passRouteToProps(route)
	},
	{
		path: '/payments/view/:id',
		name: 'paymentsview',
		component: () => import('./pages/payments/view.vue'),
		props: true
	},


	//Password reset routes
	{
		path: '/index/forgotpassword',
		name: 'forgotpassword',
		component: () => import('./pages/index/forgotpassword.vue'),
		props: true
	},
	{
		path: '/index/resetpassword',
		name: 'resetpassword',
		component: () => import('./pages/index/resetpassword.vue'),
		props: true
	},
	{
		path: '/index/resetpassword_completed',
		name: 'resetpassword_completed',
		component: () => import('./pages/index/resetpassword_completed.vue'),
		props: true
	},

	// Custom routes
	{
		path: '/custom/contact',
		name: 'customcontact',
		component: () => import('./pages/custom/contact.vue'),
		props: true
	},
	{
		path: '/custom/faqs',
		name: 'customfaqs',
		component: () => import('./pages/custom/faqs.vue'),
		props: true
	},




	{
		path: '/error/forbidden',
		name: 'forbidden',
		component: () => import('./pages/errors/forbidden.vue'),
		props: true
	},
	{
		path: '/error/notfound',
		name: 'notfound',
		component: () => import('./pages/errors/pagenotfound.vue'),
		props: true
	},
	{
		path: '/:catchAll(.*)',
		component: () => import('./pages/errors/pagenotfound.vue')
	}
];

export default () => {

	const auth = useAuth();


	const user = auth.user;
	if (user) {
		routes.push({ path: '/', alias: '/home', name: 'home', component: () => import(`./pages/home/home.vue`) });
	}
	else {
		routes.push({ path: '/', alias: '/index', name: 'index', component: () => import('./pages/index/index.vue') });
	}

	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion) {
			if (savedPostion) return savedPostion;
			return { top: 0 }
		}
	});

	router.beforeEach((to, from, next) => {
		const user = auth.user;
		let path = to.path;
		let authRequired = auth.pageRequiredAuth(path);

		//authenticate user
		if (authRequired && !user) {
			//user is not logged. redirect to login
			return next({ path: '/', query: { nexturl: to.fullPath } });
		}

		if (user && to.name == "index") {
			//already logged in, show home when try to access index page
			return next({ path: "/home" });
		}

		//navigate to redirect url if available
		if (to.name == "home" && to.query.nexturl) {
			return next({ path: to.query.nexturl });
		}

		//close dialog from previous page
		//store.dispatch('app/closeDialogs');

		//continue to specified route
		next();
	});

	return router;
}
